import React, { useState } from 'react';
import { View, Platform } from 'react-native';
import moment from 'moment';
import { Focusable } from '../../Focusable';
import { Text } from '../../Text';
import { Icon } from '../../Icon';
import { useStyleSheet, useThemeContext } from '../../../hooks';
import { createStyleSheet } from '../../../utils';
import { useAvailabilityEditorContext } from '../hooks';
import { Picker } from './Picker';
const format = (time) => {
    const now = moment().format('MM-DD-YYYY');
    const combined = moment(now + time, 'MM-DD-YYYY HH:mm');
    return combined.format('hh:mma');
};
export const Timeslot = ({ style, onPress, value, bound, day }) => {
    const styles = useStyleSheet(getStyles);
    const [showPicker, setShowPicker] = useState(false);
    const { PickerWrapper = React.Fragment } = useAvailabilityEditorContext();
    const { update } = useAvailabilityEditorContext();
    const { color } = useThemeContext();
    return (React.createElement(PickerWrapper, { close: () => {
            setShowPicker(false);
        } },
        React.createElement(View, { style: [styles.container, style] },
            React.createElement(Focusable, { style: [styles.trigger], onPress: () => {
                    onPress(day, value);
                    setShowPicker(true);
                } }, ({ hovered }) => (React.createElement(React.Fragment, null,
                React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.time }, format(value[bound])),
                React.createElement(Icon, { name: 'chevron-updown', size: 16, color: hovered || (showPicker && Platform.OS === 'web')
                        ? color.invert2.p56
                        : color.invert2.p26 }),
                React.createElement(View, { style: [
                        styles.underline,
                        hovered ? styles.hoveredUnderline : {},
                        showPicker && Platform.OS === 'web'
                            ? styles.activeUnderline
                            : {}
                    ] })))),
            showPicker && Platform.OS === 'web' && (React.createElement(Picker, { style: styles.picker, onSelect: (time) => {
                    const now = moment().format('MM-DD-YYYY');
                    update(day, value, {
                        [bound]: moment(now + ' ' + time, 'MM-DD-YYYY hh:mma').format('HH:mm')
                    });
                    setShowPicker(false);
                } })))));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    // @ts-expect-error react-native does not support string for zIndex
    container: Object.assign({}, (Platform.OS === 'web' ? { zIndex: 'unset' } : {})),
    trigger: {
        paddingVertical: size.C,
        alignItems: 'center',
        justifyContent: 'space-between',
        width: size.P + size.D,
        flexDirection: 'row'
    },
    underline: {
        height: 1,
        width: '100%',
        position: 'absolute',
        bottom: 0,
        backgroundColor: color.invert2.p4
    },
    hoveredUnderline: {
        backgroundColor: color.invert2.p42
    },
    activeUnderline: {
        backgroundColor: color.primary.solid
    },
    time: {
        color: color.invert2.p100
    },
    dropdown: {
        position: 'absolute',
        top: '100%',
        padding: size.B
    },
    dropdownText: {
        fontSize: size.F,
        lineHeight: size.H,
        letterSpacing: -0.01,
        fontWeight: '500',
        color: color.invert2.p100
    },
    picker: {
        position: 'absolute',
        top: '100%',
        shadowColor: 'rgba(28, 29, 40, 0.1)',
        shadowOffset: { width: 0, height: 8 },
        shadowRadius: 42
    }
}));
//# sourceMappingURL=Timeslot.js.map